export default __webpack_public_path__ + "static/media/operation-unit.b5cf0b0f.docx";